/*
 * "Frequently bought together" bundle.
 *
 * The main product is added via the page's real product form so variant selection
 * and any form validation still apply; the ticked add-ons are appended in the same
 * /cart/add.js request so the shopper gets one cart update, not several.
 */
class HBBundle extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[data-hb-bundle-option]'));
    this.totalEl = this.querySelector('[data-hb-bundle-total]');
    this.countEl = this.querySelector('[data-hb-bundle-count]');
    this.addButton = this.querySelector('[data-hb-bundle-add]');
    this.statusEl = this.querySelector('[data-hb-bundle-status]');
    this.mainPrice = this.parseMoney(this.querySelector('.hb-bundle__item--main .hb-bundle__price'));

    this.formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'PKR',
      maximumFractionDigits: 0,
    });

    this.options.forEach((input) => input.addEventListener('change', () => this.refresh()));
    this.addButton.addEventListener('click', () => this.addAll());
    this.refresh();
  }

  // Read the server-rendered price so formatting stays consistent with the theme.
  parseMoney(el) {
    if (!el) return 0;
    const digits = el.textContent.replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  get selected() {
    return this.options.filter((input) => input.checked);
  }

  refresh() {
    const addonTotal = this.selected.reduce((sum, input) => sum + parseInt(input.dataset.price, 10), 0);
    const total = this.mainPrice + addonTotal;
    this.totalEl.textContent = this.formatter.format(total / 100);
    this.countEl.textContent = this.selected.length + 1;
  }

  async addAll() {
    this.addButton.disabled = true;
    this.setStatus('');

    const items = this.selected.map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }));
    const mainForm = document.querySelector('product-form form[action*="/cart/add"]');

    try {
      if (mainForm) {
        // Submitting the real form keeps Dawn's cart drawer and error handling intact.
        const formData = new FormData(mainForm);
        await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData });
      }
      if (items.length) {
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
      }
      // Let Dawn refresh its own cart UI rather than reimplementing it here.
      document.dispatchEvent(new CustomEvent('hb:bundle:added'));
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (error) {
      this.setStatus('Could not add to cart. Please try again.');
      this.addButton.disabled = false;
    }
  }

  setStatus(message) {
    this.statusEl.textContent = message;
    this.statusEl.hidden = !message;
  }
}

if (!customElements.get('hb-bundle')) {
  customElements.define('hb-bundle', HBBundle);
}
